import { Alert, Box, Button, IconButton } from '@mui/material';
import React, { useEffect } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { localRoutes, remoteRoutes } from '../constants';
import useAuth from '../hooks/useAuth';
import { searchData } from '../utils/fetchHelpers';
import { ProductCategory } from '../__generated__/kycTypes';
import { useNavigate } from 'react-router-dom';
import { productDisplayName } from '../pages/management/settings/config';


interface IProps {
  marginTop?: number
  marginBottom?: number
  marginX?: number
  productCategories: ProductCategory[]
}

export const CreditsUsageAlert = ({ marginTop, marginBottom, marginX, productCategories }: IProps) => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const [showAlerts, setShowAlerts] = React.useState<boolean[]>([]);

  useEffect(() => {
    const checkCredits = async (category: string): Promise<boolean> => {
      if (!user?.partnerId) return false;
      try {
        const response = await searchData(remoteRoutes.subscriptionCreditsUsage, {
          category,
          partnerId: user.partnerId
        });
        return response?.creditsBalance === 0;
      } catch (error) {
        return false;
      }
    };

    const checkAllCategories = async () => {
      if (productCategories.length > 0) {
        const alerts = await Promise.all(productCategories.map(checkCredits));
        setShowAlerts(alerts);
      }
    };

    checkAllCategories();

  }, [user?.partnerId]);

  const handleAlertClose = (index: number) => {
    setShowAlerts((prev) => {
      const newAlerts = [...prev];
      newAlerts[index] = false;
      return newAlerts;
    });
  };

  const handleClick = (selectedProduct: string) => {
    const targetPath = `${localRoutes.settings}?tab=plans-and-billing&product=${selectedProduct}`;
    navigate(targetPath);
  };

  return (
        <>
            {showAlerts.map((showAlert, index) => (
              showAlert && (
                    <Alert
                        key={index}
                        severity="warning"
                        sx={{
                          mt: marginTop ?? 0,
                          mb: marginBottom ?? 0,
                          mx: marginX ?? 0,
                          pt: 1,
                          pb: 2
                        }}
                        action={
                            <Box>
                              <Button
                                  color="inherit"
                                  size="small"
                                  variant="outlined"
                                  onClick={() => handleClick(productCategories[index])}
                              >
                                Buy More Credits
                              </Button>
                                <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    sx={{ ml: 2 }}
                                    onClick={() => handleAlertClose(index)}
                                >
                                    <CloseIcon/>
                                </IconButton>
                            </Box>
                        }
                        onClose={() => handleAlertClose(index)}
                    >
                        {'You\'ve run out of '}<strong>{`${productDisplayName(productCategories[index]).toUpperCase()}`}</strong>{' credits. Buy more credits to avoid service interruptions.'}
                    </Alert>
              )
            ))}
        </>
  );
};
